import { createFileRoute } from "@tanstack/react-router";
import { StoreSettingsForm } from "@/components/admin/store-settings-form";
import { storeSettingsQuery } from "@/lib/settings.functions";

export const Route = createFileRoute("/admin/configuracoes")({
  loader: async ({ context }) => context.queryClient.ensureQueryData(storeSettingsQuery()),
  component: ConfiguracoesPage,
});

function ConfiguracoesPage() {
  const settings = Route.useLoaderData();

  return (
    <div>
      <h1 className="mb-2 font-display text-2xl font-bold text-eg-dark">Configurações da Loja</h1>
      <p className="mb-6 text-sm text-muted-foreground">
        Esses dados aparecem no rodapé, no menu e nas páginas legais (Termos, Privacidade, Trocas e
        Devoluções).
      </p>
      <StoreSettingsForm settings={settings} />
    </div>
  );
}
